"use strict";

var _classCallCheck = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/createClass.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeLazy = void 0;

var LazyIterableIterator = /*#__PURE__*/function (_Symbol$iterator) {
  function LazyIterableIterator(producer) {
    _classCallCheck(this, LazyIterableIterator);

    this.producer = producer;
  }

  _createClass(LazyIterableIterator, [{
    key: _Symbol$iterator,
    value: function value() {
      if (this.it === undefined) {
        this.it = this.producer();
      }

      return this.it;
    }
  }, {
    key: "next",
    value: function next() {
      if (this.it === undefined) {
        this.it = this.producer();
      }

      return this.it.next();
    }
  }]);

  return LazyIterableIterator;
}(Symbol.iterator);

function makeLazy(producer) {
  return new LazyIterableIterator(producer);
}

exports.makeLazy = makeLazy;